import type { User } from '@/data/User';
import type { UserPermission } from '@/stores/usePermissionsStore';

export const isAuthorized = (user: User, requiredPermissions: UserPermission[]) => {
  const userPermissions = user?.permissionGroups ?? [];
  return requiredPermissions.some((p) => userPermissions.includes(p));
};
